import { useMediaQuery, useTheme } from '@mui/material';
/**
 * Same as MUI's useMediaQuery, except that it only supports breakpoints.up
 * queries and will return null until the media query is actually evaluated
 * (instead of returning false by default like MUI's version does).
 * @param above The predefined breakpoint size to detect
 * @returns {boolean | null} Null until the media query evaluates, and then
 * a boolean indicating whether or not the screen width is greater than the
 * specified breakpoint.
 */
export function useNullableMediaQuery(above) {
    const theme = useTheme();
    // Setting `defaultMatches` here tells MUI to return null until
    // the media query actually executes and a real result is returned.
    return useMediaQuery(theme.breakpoints.up(above), { defaultMatches: null });
}
